<template>
  <div class="sticky-wrapper">
    <table class="table border-bottom table-bordered table-sm">
      <thead>
      <tr>
        <th rowspan="2" class="text-center bg-light sticky-left sticky-top" style="width: 100px; min-width: 100px;">{{ $t('カテゴリー名')}}</th>
        <th rowspan="2" class="text-center bg-light sticky-left sticky-top" style="left: 100px; min-width: 400px;">{{ $t('スキル名') }}</th>
        <th rowspan="2" class="text-center bg-light sticky-left sticky-top" style="left: 500px; width: 40px; height: 30px;">{{ $t('配点倍数') }}</th>
        <th v-for="user in evaluatees" :colspan="numColsPerStaff" class="text-center bg-light sticky-top bg-light" style="min-width: 120px; height: 30px;">
          {{ user.name }}
        </th>
      </tr>
      <tr>
        <template v-for="user in evaluatees">
          <th class="text-center sticky-top bg-light" style="width: 60px; top: 31px;">
            {{ $t('自己') }}
          </th>
          <th v-for="n in numStages" class="text-center sticky-top bg-light" style="width: 60px; top: 31px;">
            {{ $t(`${n}次`) }}
          </th>
        </template>
      </tr>
      </thead>

      <tbody>
        <template v-for="skillCategory in job.skillCategories">
          <!--カテゴリー -->
          <tr>
            <td :rowspan="skillCategory.numSkills + 1" class="text-center sticky-left" style="width: 100px; min-width: 100px;">
              {{ skillCategory.name }}
            </td>
          </tr>

          <!--スキル -->
          <tr v-for="skill in skillCategory.skills">
            <td class="sticky-left" style="left: 100px; width: 400px; min-width: 100px;">{{ skill.name }}</td>
            <td class="text-center sticky-left" style="left: 500px; width: 40px; height: 30px;">{{ skill.formattedPoint }}</td>

            <!--各ユーザーの評価-->
            <template v-for="(user, index) in evaluatees">
              <!--自己評価-->
              <td class="text-center">
                {{ formatScore(user.selfEvaluation, skill) }}
                <i class="comment-readonly fas fa-comment ml-1 pointer" v-if="user.selfEvaluation.comments[skill.id]" :data-content="user.selfEvaluation.comments[skill.id]"></i>
              </td>

              <!--n次評価-->
              <template v-for="n in numStages">
                <td v-if="evaluator.shouldEvaluate(n, user.id)" class="text-center" style="min-width: 100px">
                  <div class="input-group">
                    <select
                      :form="formId"
                      class="form-control form-control-sm score-select"
                      :name="`scores[${user.id}][${n}][${skill.id}]`"
                      :tabindex="index" required
                      v-model="user.otherEvaluations[n].scores[skill.id]"
                    >
                      <option></option>
                      <option v-for="rank in ranks" :value="rank.value">{{ Math.round(rank.value * skill.point * 100) / 100 }}</option>
                    </select>
                    <div class="input-group-append">
                      <button class="btn btn-light btn-sm border comment" style="z-index: 1" @click="openSkillComment(user.otherEvaluations[n], skill.id)">
                        <i class="fa-comment" :class="user.otherEvaluations[n].comments[skill.id] ? 'fas' : 'far'"></i>
                      </button>
                      <input :form="formId" type="hidden" :name="`skill_comments[${user.id}][${n}][${skill.id}]`" v-model="user.otherEvaluations[n].comments[skill.id]" />
                    </div>
                  </div>

                  <input :form="formId" type="hidden" :name="`type[${user.id}]`" value="OTHER">
                  <!--評価の数値が入力されていない時でもコメントが保存できるようにダミーのフォームを用意-->
                  <input :form="formId" type="hidden" :name="`scores[${user.id}][${n}][dummy]`" value="">
                </td>
                <td v-else class="text-center">
                  {{ formatScore(user.otherEvaluations?.[n], skill) }}
                  <i class="comment-readonly fas fa-comment ml-1 pointer" v-if="user.otherEvaluations?.[n].comments[skill.id]" :data-content="user.otherEvaluations?.[n].comments[skill.id]"></i>
                </td>
              </template>

            </template>
          </tr>

        </template>

        <!--合計点-->
        <tr>
          <td class="sticky-left text-center" colspan="3">{{ $t('合計点') }}</td>
          <template v-for="user in evaluatees">
            <!--自己評価合計は確定してから表示する-->
            <td class="text-center">{{ user.selfEvaluation.isClosed() ? user.selfEvaluation?.totalScore : '' }}</td>
            <!--他者評価合計は自身が評価すべき項目であれば未確定でも表示する-->
            <td v-for="n in numStages" class="text-center">
              {{ (evaluator.shouldEvaluate(n, user.id) || user.otherEvaluations[n]?.isClosed())
                  ? user.otherEvaluations[n]?.totalScore : ''
              }}
              {{ (evaluator.shouldEvaluate(n, user.id) || user.otherEvaluations[n]?.isClosed())
              ? '(' + Math.round((user.otherEvaluations[n]?.totalScore / user.otherEvaluations[n]?.totalMaxScore) * 10000) / 100 + '%)' : ''
              }}
            </td>
          </template>
        </tr>

        <!--コピーボタン-->
        <tr>
          <td colspan="3" class="text-center sticky-left" style="z-index: 1000;"></td>
          <th v-for="user in evaluatees" :colspan="numColsPerStaff" class="text-center" style="min-width: 240px; height: 30px;">
            <div v-if="isCopyButtonVisible(user)" class="input-group">
              <select class="form-control" v-model="copyOptionOf[user.id]">

                <template v-for="toStage in evaluator.getStages(user.id)">
                  <!--自己評価-->
                  <option v-if="canCopy(user, 0)" :value="`0-${toStage}`">
                    {{ $t('自己') }} -> {{ $t(`${toStage}次`) }}
                  </option>

                  <!--他者評価-->
                  <template v-for="fromStage in numStages">
                    <option v-if="fromStage < toStage && canCopy(user, fromStage)" :value="`${fromStage}-${toStage}`">
                      {{ $t(`${fromStage}次`) }} -> {{ $t(`${toStage}次`) }}
                    </option>
                  </template>

                </template>

              </select>
              <div class="input-group-append">
                <button class="btn btn-success" @click="copyEvaluation(user)" :disabled="!copyOptionOf[user.id]">{{ $t('コピー') }}</button>
              </div>
            </div>
          </th>
        </tr>

        <!--コメント欄-->
        <tr>
          <td class="sticky-left text-center" colspan="2" :rowspan="numStages + 1">{{ $t('コメント') }}</td>
          <td>{{ $t('自己') }}</td>
          <td v-for="user in evaluatees" class="align-top" type="text" :colspan="numColsPerStaff">
            <p>{{ user.selfEvaluation?.comment }}</p>
          </td>
        </tr>
        <tr v-for="n in numStages">
          <td>{{ $t(`${n}次評価`) }}</td>
          <td v-for="user in evaluatees" class="align-top" type="text" :colspan="numColsPerStaff">
            <textarea
              v-if="evaluator.shouldEvaluate(n, user.id)"
              :form="formId" :name="`comments[${user.id}][${n}]`"
              class="form-control mb-3"
              :placeholder="$t('コメント')"
              v-model="user.otherEvaluations[n].comment"
              rows="4"
            ></textarea>
            <p v-else>{{ user.otherEvaluations ? user.otherEvaluations[n]?.comment : '' }}</p>
          </td>
        </tr>

        <!--個人目標-->
        <template v-if="personalGoalStages">
          <tr v-for="(personalGoalStage, i) in personalGoalStages">
            <td :rowspan="personalGoalStages.length " class="text-center col1" v-if="i === 0">{{ personalGoalTitle }}</td>
            <td colspan="2">{{ personalGoalStage.name }}</td>
            <td v-for="user in evaluatees" :colspan="numColsPerStaff">
              <template v-if="user.selfEvaluation.isClosed()">
                <div v-for="goal in personalGoals[user.id]?.[personalGoalStage.id]">{{ goal.name }}：{{ goal.score }}</div>
              </template>
            </td>
          </tr>
        </template>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="3" class="text-center sticky-left" style="width: 100px; min-width: 100px;"></td>
          <th v-for="user in evaluatees" :colspan="numColsPerStaff" class="text-center" style="min-width: 120px; height: 30px;">
            <div v-if="user.isFinalEvaluationStarted" class="text-danger">{{ $t('最終評価が開始されています。') }}</div>

            <!--修正ボタン関連-->
            <template v-else-if="isReopenButtonVisible(user)">
              <button
                form="reopenForm"
                type="submit"
                class="btn btn-sm btn-success"
                name="user_id"
                :value="user.id"
              >
                {{ $t('修正') }}
              </button>
              <input
                v-for="evaluation in evaluator.getTargetEvaluationsOf(user)"
                form="reopenForm"
                type="hidden"
                :name="`evaluation_ids[${user.id}][]`"
                :value="evaluation.id"
              >
            </template>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>

  <!--保存関連のボタン-->
  <div v-if="hasOpenEvaluation" class="text-center mt-3">
    <button :form="formId" type="submit" class="btn btn-wide btn-light border" name="status" value="OPEN" formnovalidate>{{ $t('下書き保存') }}</button>
    <button :form="formId" type="submit" class="btn btn-wide btn-primary ml-1" name="status" value="CLOSED">{{ $t('確定') }}</button>
  </div>

  <!-- Popover用のテンプレート -->
  <div style="display: none;">
    <div ref="template">
      <textarea class="form-control form-control-sm mb-2" rows="4" v-model="skillComment"></textarea>
      <div class="text-right">
        <button class="btn btn-primary btn-sm" @click="saveSkillComment(skillComment)">設定</button>
      </div>
    </div>
  </div>
</template>

<script>
import Job from "../../models/Job";
import Evaluator from "../../models/Evaluator";

export default {
  props: {
    initialEvaluator: {
      type: Object,
      required: true,
    },
    initialJob: {
      type: Object,
      required: true,
    },
    initialEvaluations: {
      type: Object,
      required: true,
    },
    numStages: {
      type: Number,
      required: true,
    },
    ranks: {
      type: Array,
      required: true,
    },
    formId: {
      type: String,
      required: true,
    },
    personalGoals: {
      type: Object,
      required: true
    },
    personalGoalStages: {
      type: Array,
      required: true
    },
    personalGoalTitle: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      evaluator: null,
      job: {},
      numColsPerStaff: this.numStages + 1, // ステージ数 + 自己評価,
      copyOptionOf: {},
      skillComment: '',
      skillCommentTarget: {}
    }
  },

  computed: {
    evaluatees() {
      return this.evaluator?.evaluatees;
    },
    hasOpenEvaluation() {
      return this.evaluator?.hasOpenEvaluation();
    }
  },

  mounted() {
    const self = this;
    this.job = new Job(this.initialJob);
    this.evaluator = new Evaluator(this.initialEvaluator);

    // 被評価者それぞれの評価・特別評価を読み込む
    Object.keys(this.evaluatees).forEach(userId => {
      const user = this.evaluatees[userId];
      user?.loadEvaluations(this.initialEvaluations[userId], this.numStages);
    })

    // コピー機能用
    Object.keys(this.evaluatees).forEach(userId => {
      this.copyOptionOf[userId] = null;
    });

    // FIXME: 純粋なVueに移植する
    $(function() {
      $('.comment').popover({
        container: 'body',
        html: true,
        sanitize: false,
        trigger: 'manual',
        content: self.$refs.template
      });
      $('.comment').on('click', function() {
        $('.comment').popover('hide');
        $(this).popover('show');
      });
      $('.comment-readonly').popover({
        container: 'body'
      });
    });
  },

  methods: {
    /**
     * 被評価者の指定のstageの評価をコピーできるか判定する
     *
     * @param {User} evaluatee
     * @param {number} stage
     */
    canCopy(evaluatee, stage) {
      const sourceEvaluation = stage === 0 ? evaluatee.selfEvaluation : evaluatee.otherEvaluations[stage];

      // evaluatorが担当する評価であれば無条件にコピー可能、そうでない場合は確定済みの評価であればコピー可能とする
      return this.evaluator.shouldEvaluate(stage, evaluatee.id) || sourceEvaluation.isClosed();
    },

    /**
     * 指定の被評価者の評価をコピーする
     *
     * @param {User} evaluatee
     */
    copyEvaluation(evaluatee) {
      const [fromStage, toStage] = this.copyOptionOf[evaluatee.id].split('-').map(e => parseInt(e));
      if (!this.evaluator.shouldEvaluate(toStage, evaluatee.id)) {
        return;
      }

      const targetEvaluation = evaluatee.otherEvaluations[toStage];
      if (!targetEvaluation) {
        return;
      }

      const sourceEvaluation = fromStage === 0 ? evaluatee.selfEvaluation : evaluatee.otherEvaluations[fromStage];

      sourceEvaluation.copy(targetEvaluation);
    },

    /**
     * コピーボタンを表示させるかどうか
     *
     * @param {User} user
     * @return {boolean}
     */
    isCopyButtonVisible(user) {
      if (user.isFinalEvaluationStarted) {
        return false;
      }
      return this.evaluator?.hasOpenEvaluationOf(user);
    },

    /**
     * 修正ボタンを表示させるかどうか
     *
     * @param {User} user
     * @return {boolean}
     */
    isReopenButtonVisible(user) {
      if (user.isFinalEvaluationStarted) {
        return false;
      }
      return !this.evaluator?.hasOpenEvaluationOf(user);
    },

    /**
     * 評価をフォーマットする
     * 評価未入力or未確定の場合は空文字を出力する
     *
     * @param {Evaluation|null} evaluation
     * @param {Skill} skill
     */
    formatScore(evaluation, skill) {
      if (!evaluation || !evaluation.isClosed()) {
        return '';
      }

      const score = evaluation?.getScoreBySkillId(skill.id);
      return score !== null ? Math.round(score * skill.point * 100) / 100 : '';
    },

    /**
     * スキル別コメント用ポップオーバーを表示
     * FIXME: 現在、表示処理自体はJQueryの枠組みでやっている。
     *
     * @param evaluation
     * @param skillId
     */
    openSkillComment(evaluation, skillId) {
      this.skillComment = evaluation.comments[skillId];
      this.skillCommentTarget = { evaluation, skillId };
    },

    /**
     * スキル別コメントを設定する
     *
     * @param comment
     */
    saveSkillComment(comment) {
      const evaluation = this.skillCommentTarget.evaluation;
      const skillId = this.skillCommentTarget.skillId;
      evaluation.comments[skillId] = comment;
      $('.comment').popover('hide');
    }
  }
}
</script>
